"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const team = [{
  name: "Marcus Thorne",
  position: "Logistics Director",
  bio: "With 15 years in heavy-lift operations, Marcus ensures every complex route is mapped for maximum efficiency and safety.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/mover_expert_marcus.png"
}, {
  name: "Elena Rodriguez",
  position: "Inventory Specialist",
  bio: "Expert in high-value asset protection and digital inventory tracking, ensuring zero-loss transitions for every client.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/mover_expert_elena.png"
}];
export default function MeetTheExperts() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222887" id="meet-the-experts" className="bg-background text-foreground py-24 px-6 md:px-12 overflow-hidden">
      <div ref={ref} className={`max-w-6xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="mb-20 text-center">
          <h2 className="font-default text-3xl md:text-5xl font-bold uppercase tracking-tight mb-4">
            Meet the Experts
          </h2>
          <div className="w-12 h-[2px] bg-primary mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24">
          {team.map((member, i) => <div data-index={i} key={i} className="group relative flex flex-col">
              {}
              <div className="relative aspect-[3/4] w-full overflow-hidden bg-muted rounded-md border border-border">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover grayscale transition-all duration-700 ease-in-out group-hover:grayscale-0 group-hover:scale-105" />
                {}
                <div className="absolute inset-0 pointer-events-none opacity-10 bg-[linear-gradient(to_right,#000_1px,transparent_1px),linear-gradient(to_bottom,#000_1px,transparent_1px)] bg-[size:32px_32px]"></div>
              </div>

              {}
              <div className="relative -mt-20 mx-4 sm:mx-8 z-10 bg-card/90 backdrop-blur-md border border-border p-6 md:p-8 shadow-xl transition-transform duration-500 group-hover:-translate-y-2 rounded-md">
                <div className="flex flex-col items-start">
                  <div className="font-default text-2xl font-bold tracking-tight mb-1 text-foreground uppercase">
                    {member.name}
                  </div>
                  <div className="font-mono text-xs uppercase tracking-widest text-primary font-semibold mb-6">
                    {member.position}
                  </div>
                  
                  <div className="w-full">
                    <div className="font-mono text-[10px] uppercase tracking-widest text-secondary mb-3 flex items-center gap-2">
                      <span className="w-3 h-[2px] bg-primary inline-block"></span>
                      Specialty Focus
                    </div>
                    <p className="text-sm text-foreground/80 leading-relaxed font-default">
                      {member.bio}
                    </p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}